/** src/components/ui/HotelCTAGroup.js */
// Import Core
import React from 'react';
import styled from 'styled-components';
// Import Tracking Utils
import handleTrackingLinkClicks from '../../utils/tracking/handleTrackingLinkClick';
// Import Components
import { Button } from './Button';

/* Styled Components */
const HotelCTAGroupStyles = styled.div`
	display: flex;
	a {
		text-decoration: none;
		width: 100%;
		button {
			width: 100%;
		}
	}
`;

/* Components */
const DisplayPaidOrStubContent = ({ website, hasPaid, bookNowUrl, bookingUrl, hotelName, slug }) => {
	const websiteUrl = website?.includes('https') ?   website : website?.replace('http', 'https');
	const bookingUrl2 = bookingUrl?.includes('https') ?  bookingUrl : bookingUrl?.replace('http', 'https');
	const bookNowUrl2 = bookNowUrl?.includes('https') ? bookNowUrl: bookNowUrl?.replace('http', 'https');
	if (hasPaid) {
			return (
				<>
				{website &&
					<a href={websiteUrl} className='see_hotel_website' target='_blank' onClick={() => handleTrackingLinkClicks('Website', hotelName, slug )}>
						<Button className='large'>See Hotel Website</Button>
					</a>
				}
				{bookNowUrl &&
					<a href={bookNowUrl2} className='book_direct_with_hotel' target='_blank' onClick={() => handleTrackingLinkClicks('Direct Booking', hotelName, slug )}>
						<Button className='primary-outline-btn large'>
							Book direct with hotel
						</Button>
					</a>
				}
				</>
			);
		// } else {
		// 	return false;
		// }
	} else {
			return bookingUrl ?
			(
				<a href={bookingUrl} className='check_availability' target='_blank' onClick={() => handleTrackingLinkClicks('booking.com', hotelName, slug )}>
					<Button className='primary-outline-btn large'>Check Availability</Button>
				</a>
			)
			: false;
	}
};

/* Render Component */
const HotelCTAGroup = ({
	website,
	bookingUrl,
	bookNowUrl,
	displayEmail,
	email,
	telephone,
	hasPaid,
	hotelName,
	slug,
}) => {
	return (
		<HotelCTAGroupStyles className={`hotel_cta-group ${hasPaid ? "":"unpaid"}`}>
			<DisplayPaidOrStubContent
				website={website}
				hasPaid={hasPaid}
				bookNowUrl={bookNowUrl}
				bookingUrl={bookingUrl}
				hotelName={hotelName}
				slug={slug}
			/>

			{/* If display email is checked show email otherwise show telephone */}
			{
				displayEmail === true && email && (
					<a href={`mailto:${email}`} className='email_hotel' target='_blank' onClick={() => handleTrackingLinkClicks('Email', hotelName, slug )}>
						<Button className='light-btn large'>email hotel</Button>
					</a>
				)
				// TODO: Telephone in correct format????
				// || telephone &&
				//   <a href={`tel:${telephone}`} target="_blank" rel="noreferrer">
				//   <Button className="light-btn large">Tel hotel</Button>
				//   </a>
			}
		</HotelCTAGroupStyles>
	);
};

export default HotelCTAGroup;
